import { __awaiter, __generator } from "tslib";
import { getOriginParam } from '@office-start/file-utility';
import { appendQuery } from '@office-start/url-parser-utility';
export function addLoginHint(url, context, capabilities) {
    if (context &&
        context.loginHint &&
        capabilities &&
        capabilities.outgoingLoginHintEnabled) {
        appendQuery(url, "login_hint=".concat(context.loginHint));
    }
    return url;
}
export function getGraphDriveItemUrlModel(newFile, clickTime, context, sharedContext, templateId, templatesConfig, capabilities) {
    return __awaiter(this, void 0, void 0, function () {
        var fileUrlModel, webUrl, editNewQueryParam, origin;
        return __generator(this, function (_a) {
            fileUrlModel = {};
            if (newFile.webDavUrl) {
                fileUrlModel.canonicalUrl = addLoginHint(newFile.webDavUrl, context, capabilities);
            }
            webUrl = addLoginHint(newFile.webUrl, context, capabilities);
            editNewQueryParam = 'action=editnew';
            webUrl = webUrl.replace(new RegExp('([?&])action[^&]*'), '$1' + editNewQueryParam);
            if (webUrl.lastIndexOf(editNewQueryParam) === -1) {
                webUrl = appendQuery(webUrl, editNewQueryParam);
            }
            if (templateId) {
                webUrl = appendQuery(webUrl, "wdTpl=".concat(templateId));
            }
            if (templateId || (templatesConfig && templatesConfig.createLcidEnabled)) {
                webUrl = appendQuery(webUrl, "wdlcid=".concat(sharedContext.officeMarketLcid));
            }
            if (capabilities && capabilities.scenarioId) {
                webUrl = appendQuery(webUrl, "wdscenarioid=".concat(capabilities.scenarioId));
            }
            origin = getOriginParam(context.workload, context.router.getCurrentRoute(), false, !!templateId);
            webUrl = appendQuery(webUrl, "wdNewAndOpenCt=".concat(clickTime, "&ct=").concat(clickTime, "&wdPreviousSession=").concat(context.correlationId, "&wdOrigin=").concat(origin));
            fileUrlModel.webUrl = webUrl;
            // TODO - UI Host?
            // const shouldOpenInUIHost = !templateDriveId || this.capabilitiesService.capabilities.wacHostOrgTemplatesEnabled)
            //     && this.capabilitiesService.wacHostEnabledForFileType(app)
            //     && this.wacHostApps
            //     && this.wacHostApps.has(app);
            // if (shouldOpenInUIHost) {
            //     if (newFile.parentReference) {
            //         fileUrlModel.docId = newFile.id;
            //         fileUrlModel.driveId = newFile.parentReference.driveId;
            //         fileUrlModel.fileName = newFile.name;
            //     }
            //     fileUrlModel.wopiFetchData = {
            //         fetchDiagnostics: { startTime },
            //         wopiHostData: VroomService.getWopiHostDataFromItem(newFile),
            //     };
            // }
            return [2 /*return*/, fileUrlModel];
        });
    });
}
//# sourceMappingURL=getGraphDriveItemUrlModel.js.map